import React from 'react'
import {isRouteErrorResponse, useRouteError} from 'react-router-dom'
import {submitError} from '../../errorReport'
import {ErrorLayout} from './components/ErrorLayout'
import {BackLinkInternNavigasjon} from "../../components/BackLinkInternNavigasjon";
import {config} from "../../environment";
import Layout from "../../components/Layout";

export default function ErrorHandler() {
    const error = useRouteError()

    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            submitError('Bruker har kommet til en side som ikke finnes', error)
            return (
                <Layout>
                    <BackLinkInternNavigasjon url={config.linkBarnehageBaseUrl} text={'Din barnehageside'}/>
                    <ErrorLayout>
                        <h1 className={'pkt-txt-22 mb-size-20'}>404 - Beklager, vi finner ikke siden du leter
                            etter</h1>
                        <p>Det kan være at siden er slettet, eller at det er en feil i lenken du fulgte for å komme
                            hit.</p>
                        <p><a href={"https://www.oslo.kommune.no/barnehage/"}>Gå til startsiden for barnehage</a>
                        </p>
                    </ErrorLayout>
                </Layout>)
        }
    }

    submitError('Errorhandleren default beskjed er blitt vist til brukeren', error)
    return (
        <Layout>
            <BackLinkInternNavigasjon url={config.linkBarnehageBaseUrl} text={'Din barnehageside'}/>
            <ErrorLayout>
                <h1 className={'pkt-txt-22'}>Beklager, det skjedde en feil. Vi jobber med å fikse den.</h1>
            </ErrorLayout>
        </Layout>
    )
}